import type { InvoiceListQueryParams } from "./useInvoiceListQuery";

export const INVOICE_QUERY_KEYS = {
  all: ["INVOICES"] as const,
  list: (params: InvoiceListQueryParams) =>
    [...INVOICE_QUERY_KEYS.all, "LIST", params] as const,
} as const;
